import { Component, OnInit, Input } from '@angular/core';
import { CalculatorService } from 'app/calculators/calculator.service';

@Component({
  selector: 'app-bank-rate-calculation-result',
  templateUrl: './bank-rate-calculation-result.component.html',
  styleUrls: ['./bank-rate-calculation-result.component.css']
})
export class BankRateCalculationResultComponent implements OnInit {
  offer: any;
  roi: any;
  condition: any;

  constructor(public calculatorService: CalculatorService) { }

  ngOnInit() {
    this.calculatorService.currentValues.subscribe(result => {
       if (result !== 'default') {
        this.offer = result;
       }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/bank-rate-calculation-result/bank-rate-calculation-result.component.ts